/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m30.8505946 30.5252959c-.182995.2954382-.5039863.4747041-.8509768.4747041h-27.99923561c-.34699053 0-.66798177-.1792659-.85097677-.4747041-.18199503-.2954383-.19899457-.663985-.0439988-.9744455l13.99961778-28.041595c.3399908-.6790072 1.4499604-.6790072 1.7899512 0l13.9996178 28.041595c.1549957.3104605.1379962.6790072-.0439988.9744455zm-2.4689326-1.528267-12.381662-24.80078781-12.38166198 24.80078781zm-12.381662-6.2813173c.9019754 0 1.6369553.7350904 1.6369553 1.6384304 0 .9043414-.7349799 1.6384303-1.6369553 1.6384303s-1.6369553-.7340889-1.6369553-1.6384303c0-.90334.7349799-1.6384304 1.6369553-1.6384304zm0-12.0048071c.5529849 0 .9999727.4486655.9999727 1.0014855v8.2712691c0 .5538215-.4469878 1.0014855-.9999727 1.0014855s-.9999727-.447664-.9999727-1.0014855v-8.2712691c0-.55282.4469878-1.0014855.9999727-1.0014855z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;